import { useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { Dialog } from 'components';
import Panel from 'components/atoms/GefMui/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import Subheader from 'components/atoms/GefMui/Subheader';
import PAGES from 'constants/pages';
import { subheaders } from 'features/common/Subheader/constants';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { fetchSemaphoreDashboard, prefillFormAndSearch, reset } from 'features/views/semaphore/actions';
import { dialogs } from 'features/views/semaphore/constants';
import { getContextUser } from 'features/views/userContext/selectors';
import history from 'utils/history';
import { getRoutePath } from 'utils/routeHelper';

import Filter from './components/Filter';
import ResultsTable from './components/ResultsTable';
import SemaphoreInfoGraphics from './components/SemaphoreInfoGraphics';
import Toolbar from './components/Toolbar';

const Semaphore = () => {
	const dispatch = useDispatch();
	const contextUser = useSelector(getContextUser);

	const subheaderTitle = useRenderSubheaderTitle({
		contextUser,
		pageTitle: getLabelMessage('semaphore:pageTitle'),
	});

	useEffect(() => {
		dispatch(fetchSemaphoreDashboard());
	}, [dispatch]);

	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search);
		const queryData = searchParams.get('data');

		if (!isNilOrEmpty(queryData)) {
			dispatch(prefillFormAndSearch('impendingState', queryData));
			history.replace(getRoutePath('semaphore'));
		}
	}, [dispatch]);

	useEffect(
		() => () => {
			dispatch(reset());
		},
		[dispatch],
	);

	const floatingDialogs = (
		<Dialog mui name={dialogs.TOO_MANY_RESULTS}>
			{getLabelMessage('semaphore:tooManyResults')}
		</Dialog>
	);

	return (
		<Panel screenId={PAGES.semaphore.id} screenName={PAGES.semaphore.name} floatingDialogs={floatingDialogs}>
			<Paper sx={{ p: 3, borderRadius: 2 }}>
				<Stack spacing={2}>
					<Subheader title={subheaderTitle} />
					<SemaphoreInfoGraphics />
				</Stack>
			</Paper>
			<PaperWithToolbar
				toggledElement={<Filter />}
				toolbar={<Toolbar />}
				collapsibleProps={{ id: subheaders.semaphore, initiallyOpen: true }}
			>
				<ResultsTable />
			</PaperWithToolbar>
		</Panel>
	);
};

export default Semaphore;
